import React from 'react'
import Link from 'gatsby-link'

import Page from '../page'

import Slider from './slider/slider'

import ExcerptList from './post/excerptList'
import PostExcerpt from './post/excerpt'
import Navigation from './navigation'

import Featured from './featured'

import globalState from '../helpers/globalState'

class HomePage extends React.PureComponent {
  render() {
    //,
    const slides = this.props.data.frontpage.acf.slider
      ? this.props.data.frontpage.acf.slider.map(slide => ({
          image: {
            sizes: slide.featured_media.localFile.childImageSharp.sizes,
            bgColor: slide.featured_media.localFile.childImageSharp.bgColor,
          },

          // background
          // lines: slide.slider_show_title ? [slide.title] : [],
          link: slide.link,
        }))
      : []

    return (
      <div>
        {this.props.data.frontpage.acf.slider && <Slider slides={slides} />}
        {this.props.data.frontpage.acf.featured_articles && (
          <ExcerptList>
            {this.props.data.frontpage.acf.featured_articles.map(article => (
              <PostExcerpt key={article.id} data={article} featured={true} />
            ))}
          </ExcerptList>
        )}
        {this.props.data.frontpage.acf.featured_pages &&
          this.props.data.frontpage.acf.featured_pages.map(page => (
            <Featured
              image={{
                ...page.featured_media.localFile.childImageSharp.sizes,
                bgColor: page.featured_media.localFile.childImageSharp.bgColor,
              }}
              title={page.title}
              link={page.link}
              key={page.link}
            />
          ))}
        <Navigation />
      </div>
    )
  }
}

export default HomePage

export const fragment = graphql`
  fragment FrontPageFragment on wordpress__PAGE {
    title
    lang
    excerpt
    yoast {
      title
      metadesc
    }
    acf {
      slider {
        title
        link
        featured_media {
          localFile {
            childImageSharp {
              bgColor
              sizes(
                maxWidth: 1870
                maxHeight: 1000
                traceSVG: { color: "#821749" }
                quality: 85
              ) {
                ...GatsbyImageSharpSizes_withWebp_noBase64
              }
            }
          }
        }
      }
      featured_articles {
        id: slug
        title
        lang
        formattedDate: date(formatString: "D.M.Y")
        categories
        excerpt
        slug
        featured_media {
          localFile {
            childImageSharp {
              bgColor
              sizes(
                maxWidth: 923
                maxHeight: 519
                traceSVG: { color: "#821749" }
                quality: 85
              ) {
                ...GatsbyImageSharpSizes_withWebp_noBase64
              }
            }
          }
        }
      }
      featured_pages {
        link
        title
        featured_media {
          localFile {
            childImageSharp {
              bgColor
              sizes(
                maxWidth: 1870
                maxHeight: 1000
                traceSVG: { color: "#821749" }
                quality: 85
              ) {
                ...GatsbyImageSharpSizes_withWebp_noBase64
              }
            }
          }
        }
      }
    }
    featured_media {
      localFile {
        childImageSharp {
          ...SEOImageFragment
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/frontpage.js